function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import { useState } from 'react';
import * as React from 'react';
import { StyledInput, Container, Label, ErrorMessage, IconContainer } from "./styles";
import { IconEye, IconEyeOff } from "../Icons";



























export const Input = ({
  label,
  error,
  inputProps = {},
  maskProps,
  width,
  disabled,
  passwordWithIcon,
  style,
  className,
  classNames = {},
  onChange,
  ...props }) =>
{
  const [withValue, setWithValue] = useState(Boolean(inputProps.value));

  const [inputType, setInputType] = useState(
  passwordWithIcon ? 'password' : inputProps.type || 'text');


  const isMaskedInput = Boolean(maskProps && maskProps.mask);

  const handleChange = (event) => {
    const { value } = event.target;

    setWithValue(Boolean(value));

    if (inputProps.onChange) {
      inputProps.onChange(event);
    } else if (onChange) {
      onChange(event);
    }
  };

  const handleClickPasswordIcon = () => {
    if (passwordWithIcon) {
      setInputType(inputType === 'password' ? 'text' : 'password');
    }
  };

  return /*#__PURE__*/(
    React.createElement(Container, _extends({
      style: { width, ...style },
      className: `${className || ''} ${classNames.container || ''}` },
    props), /*#__PURE__*/

    React.createElement(StyledInput, _extends({
      isMask: isMaskedInput,
      disabled: disabled },
    maskProps,
    inputProps, {
      placeholder: label ? undefined : inputProps.placeholder,
      type: inputType,
      onChange: handleChange,
      withIconRight: passwordWithIcon,
      className: classNames.input })),

    passwordWithIcon && /*#__PURE__*/
    React.createElement(IconContainer, {
      active: inputType === 'text',
      onClick: handleClickPasswordIcon,
      className: classNames.iconContainer },

    inputType === 'text' ? /*#__PURE__*/React.createElement(IconEye, null) : /*#__PURE__*/React.createElement(IconEyeOff, null)),


    label && /*#__PURE__*/
    React.createElement(Label, { className: `${classNames.label}`, active: withValue },
    label),


    error && /*#__PURE__*/React.createElement(ErrorMessage, { className: classNames.error }, error)));


};